import getOrderPaidProducts from './getOrderPaidProducts'

export const getOrderCatalogLabel = (products) => {
  const list = getOrderPaidProducts(products)

  if (!list.length) {
    return 'Premium'
  }

  const outletCount = list.filter((product) => product.isOutlet === true).length

  if (outletCount === 0) {
    return 'Premium'
  }

  if (outletCount === list.length) {
    return 'Outlet'
  }

  return 'Premium + Outlet'
}

export default getOrderCatalogLabel
